// extracted by mini-css-extract-plugin
export default {"container":"R4kEDp","slide":"rHVbKP","postWrapper":"YX03sk","separator":"nkVXG0"};